(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/cookie-info.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/cookie-info.js'); 
(function(svs) {
  'use strict';

  var logger = svs.core.log.getLogger('component:cookies_check_and_info');
  var corporateName = svs.core.detect.tenant('tb')
      ? 'AB Svenska Spel'
      : 'Svenska Spel Sport & Casino AB';

  function removeEvents(el) {
    el.off(
      'click',
      '.js-cookie-info-ok',
      svs.components.cookies_check_and_info.cookieInfo.onCookieInfoOk
    );
    el.off(
      'click',
      '.js-third-party-cookies-settings',
      svs.components.cookies_check_and_info.cookieInfo
        .onThirdPartyCookieSettings
    );
  }

  function setupEvents(el) {
    el.on(
      'click',
      '.js-cookie-info-ok',
      svs.components.cookies_check_and_info.cookieInfo.onCookieInfoOk
    );
    el.on(
      'click',
      '.js-third-party-cookies-settings',
      svs.components.cookies_check_and_info.cookieInfo
        .onThirdPartyCookieSettings
    );
  }

  svs.components.cookies_check_and_info.isDivider = function() {
    if (svs.core.data.baseUrl === '' && $('html.divider').length > 0) {
      return true;
    }

    return false;
  };

  svs.components.cookies_check_and_info.cookieInfo = (function() {
    return {
      show: function(force) {
        if (
          svs.components.cookies_check_and_info.dataHandler.getShowCookieInfo() &&
            window.location.pathname.indexOf('/villkor-och-integritet') < 0 ||
          force
        ) {
          var template;
          var tenant = svs.core.data.tenant;
          logger.info('Show cookie information dialog for visitor');
          if (svs.components.cookies_check_and_info.isDivider()) {
            tenant = 'vattendelarn';
            template = svs.components.cookies_check_and_info.templates.cookie_info_light(
              svs.components.cookies_check_and_info.data
            );
          } else {
            template = svs.components.cookies_check_and_info.templates.cookie_info(
              { corporateName }
            );
          }
          svs.events.publish('third_part_cookie_popup', tenant);
          svs.components.overlay.show(template, true, {
            overlayStyle: svs.core.detect.formfactor.mobile()
              ? 'auto'
              : '420px',
            overflow: 'auto',
            className: 'cookie-info-box-overlay'
          });
          setupEvents(svs.components.overlay.contentEl());
          return true;
        }
        return false;

      },
      onCookieInfoOk: function() {
        svs.components.cookies_check_and_info.dataHandler.setShowCookieInfo(
          false
        );
        svs.components.cookies_check_and_info.dataHandler.setThirdPartyCookieAccepted(
          true
        );

        removeEvents(svs.components.overlay.contentEl());
        svs.components.overlay.hide();
      },
      onThirdPartyCookieSettings: function() {
        removeEvents(svs.components.overlay.contentEl());
        svs.components.overlay.hide();
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings.show();
      }
    };
  })();
})(svs);

 })(window);